// frontend/src/pages/LoginPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Para link e redirecionamento
import { useAuth } from '../contexts/AuthContext'; // Para chamar a função de login do contexto
import api from '../services/api'; // Para chamar nossa API backend

const LoginPage = () => {
    // Estados para os campos do formulário
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    // Estados para controle de UI
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(''); // Armazena mensagens de erro da API

    // Hooks e Contexto
    const navigate = useNavigate(); // Hook para navegar programaticamente
    const { login } = useAuth(); // Obtém a função login do nosso AuthContext

    // Função para lidar com o envio do formulário
    const handleSubmit = async (e) => {
        e.preventDefault(); // Previne o comportamento padrão de recarregar a página
        setError(''); // Limpa erros anteriores
        setIsLoading(true); // Ativa o estado de carregamento

        try {
            // Chama a API de login no backend
            const response = await api.post('/auth/login', {
                email,
                password,
            });

            // Se a requisição foi bem-sucedida (status 2xx)
            console.log('Login API response:', response.data);
            // Chama a função login do AuthContext com os dados recebidos
            // A função login cuidará de salvar no localStorage e atualizar o estado global
            login(response.data);

            // Redireciona o usuário para o dashboard (ou outra página inicial)
            // 'replace: true' impede que o usuário volte para a página de login usando o botão "voltar" do navegador
            navigate('/', { replace: true });

        } catch (err) {
            // Se a requisição falhar
            console.error('Erro no login:', err);
            // Tenta pegar a mensagem de erro específica da resposta da API
            const errorMessage = err.response?.data?.message || 'Erro ao tentar fazer login. Verifique suas credenciais ou tente novamente.';
            setError(errorMessage);
        } finally {
            // Garante que o estado de carregamento seja desativado, mesmo se der erro
            setIsLoading(false);
        }
    };

    return (
        // Container principal para centralizar o formulário
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            {/* Card do formulário */}
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-center text-gray-900">
                    Entrar no Dropship Manager
                </h2>
                {/* Formulário de Login */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Campo Email */}
                    <div>
                        <label
                            htmlFor="email"
                            className="block text-sm font-medium text-gray-700"
                        >
                            Email
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isLoading} // Desabilita enquanto carrega
                            className="block w-full px-3 py-2 mt-1 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70"
                            placeholder="seuemail@example.com"
                        />
                    </div>

                    {/* Campo Senha */}
                    <div>
                        <label
                            htmlFor="password"
                            className="block text-sm font-medium text-gray-700"
                        >
                            Senha
                        </label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={isLoading}
                            className="block w-full px-3 py-2 mt-1 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70"
                            placeholder="Sua Senha"
                        />
                    </div>

                    {/* Exibição de Mensagem de Erro */}
                    {error && (
                        <p className="text-sm text-center text-red-600">
                            {error}
                        </p>
                    )}

                    {/* Botão de Submit */}
                    <div>
                        <button
                            type="submit"
                            disabled={isLoading} // Desabilita o botão durante o carregamento
                            className="relative flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md group hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {/* Texto do botão muda durante o carregamento */}
                            {isLoading ? 'Entrando...' : 'Entrar'}
                        </button>
                    </div>
                </form>

                {/* Link para Registro */}
                <p className="mt-6 text-sm text-center text-gray-600">
                    Ainda não tem uma conta?{' '}
                    <Link to="/register" className="font-medium text-indigo-600 hover:text-indigo-500">
                        Registre-se
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;